export const DATA_PRODUCT_VIEW = 'DATA_PRODUCT_VIEW'
export const SET_DM_CHAT_OPEN = 'SET_DM_CHAT_OPEN'
export const SET_DM_PRODUCTS = 'SET_DM_PRODUCTS'
